import React, { useState } from "react";
import { getDenominationStyles } from "../../../styles/banknotes-styles";
import { DeleteTwoTone } from "@material-ui/icons";
import { formatToCommaSeparate, formatToCurrency, formatToCurrencyWithScale, formatValidInput } from "../../../helpers/FormatHelper";
import NumberInput from "../../shared/NumberInput";
import { useEffect } from "react";

const denominationStyles = getDenominationStyles();

const RealignDenominationView = (props) => {
    
    const { denominations, rowId, item, removeItem, enableRemove, showStock } = props;
    const [refresh, setRefresh] = useState(false);

    let editDenominations = [];
    item.Denominations = item.Denominations || [];

    if (Array.isArray(denominations) && denominations.length > 0) {
        editDenominations = denominations.map((d, idx) => {
            const denominationItem = (item.Denominations || []).find(
                (r) => r.DenominationDescription === d.DenominationDescription
            );
            if (denominationItem === undefined) {
                item.Denominations.push({
                    DenominationDescription: d.DenominationDescription,
                    ReportedNoNotes: 0,
                });
            }      
            return (
                <div
                    id={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                    key={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                >
                    <div
                        id={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        style={denominationStyles.processingRowHeader}
                    >
                        {d.DenominationDescription}
                    </div>

                    {showStock && <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                    >
                       <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={denominationItem !== undefined && Number(denominationItem.NoNotesInStock) > 0 ? formatToCommaSeparate(denominationItem.NoNotesInStock) : '0'}
                            onChange={f => f}
                            disabled={true}
                            scale={0}
                            style={denominationStyles.processingRowCellDisabled}
                        />
                    </div>}

                    <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={
                                formatToCommaSeparate(denominationItem !== undefined && Number(denominationItem.ReportedNoNotes) > 0
                                    ? denominationItem.ReportedNoNotes
                                    : "")
                            }
                            onChange={(event) => {
                                if (
                                    event.target.value === "" ||
                                    event.target.value === null ||
                                    event.target.value === undefined
                                ) {
                                    return;
                                }
                                const denominationItem = item.Denominations.find(
                                    (r) => r.DenominationDescription === d.DenominationDescription
                                );                                                                  
                                item.ReportedValue = (item.ReportedValue || 0) - (denominationItem.ReportedNoNotes || 0) * d.DenominationValue;                                
                                denominationItem.ReportedNoNotes = Number(event.target.value);
                                item.ReportedValue = (item.ReportedValue || 0) + denominationItem.ReportedNoNotes * d.DenominationValue;                                
                                setRefresh((refresh) => !refresh);
                            }}
                            onBlur={() => {
                                setRefresh((refresh) => !refresh);
                            }}
                            scale={0}
                            style={denominationStyles.processingRowCell}
                        />
                    </div>
                    
                </div>
            );
        });

        
        editDenominations.unshift(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
            >
                <div style={denominationStyles.processingRowHeader}>
                    &nbsp;
                </div>
                {showStock && <div
                    id={`eo-div-details-rows-${rowId}-den-instock-label`}
                    key={`eo-div-details-rows-${rowId}-den-instock-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    Stock
                </div>}
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    Realign
                </div>
            </div>
        );

        editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                style={{'marginLeft': 'auto'}}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    style={denominationStyles.processingRowHeader}
                >
                    Total
                </div>                
                {showStock &&
                    <div
                        id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        style={denominationStyles.processingRowCellTotal}
                    >
                        <NumberInput
                        id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                            key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                        className={"uk-input"}
                        type="Currency"
                        value={formatToCurrencyWithScale(item.TotalAmount,item.CurrencyID)}
                        disabled={true}
                        style={denominationStyles.processingRowCellTotal}
                    />
                    </div>
                }
                <div>
                    <NumberInput
                        id={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        key={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        className={formatValidInput(item.TotalAmount === item.ReportedValue)}
                        type="Currency"
                        value={formatToCurrency(item.ReportedValue || 0)}
                        disabled={true}
                        style={denominationStyles.processingRowCellTotal}
                    />
                </div>
            </div>
        );
        enableRemove && editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    style={denominationStyles.processingRowHeader}
                >
                    &nbsp;
                </div>
                <div>
                    <DeleteTwoTone
                        style={denominationStyles.processingRowAction}
                        id={`eo-div-details-rows-delete-${rowId}`} key={`eo-div-details-rows-delete-${rowId}`}
                        onClick={() => { removeItem(item) }
                        } />
                </div>
            </div>
        );
    }

    return (
        <div style={denominationStyles.processingRow}>{editDenominations}</div>
    );
};

export default RealignDenominationView